import type { ParentComponent } from "solid-js";
import { createContext, useContext } from "solid-js";
import type { SetStoreFunction } from "solid-js/store";
import { createStore } from "solid-js/store";
import { makePersisted } from "@solid-primitives/storage";
import { useUserState } from "../../state/user";
import { isNil } from "lodash-es";

export type TourState = {
  status: "not_started" | "completed" | "skipped" | "in_progress" | "aborted";
  lastStep?: string;
};

type FormEditorTourContext = {
  tourState: TourState;
  setTourState: (state: Partial<TourState>) => void;
};

const FormEditorTourContext = createContext<FormEditorTourContext>();

export const FormEditorTourProvider: ParentComponent = (props) => {
  const user = useUserState();
  const [tourState, setTourState] = makePersisted<TourState, [TourState, SetStoreFunction<TourState>]>(
    // oxlint-disable-next-line solid/reactivity -- False-positive, 'makePersisted' retains reactivity
    createStore<TourState>({ status: "not_started" }),
    {
      name: `moreapp_form_editor_tour_${user().id}`,
      storage: localStorage,
    },
  );

  return (
    <FormEditorTourContext.Provider value={{ tourState, setTourState }}>
      {props.children}
    </FormEditorTourContext.Provider>
  );
};

export const useFormEditorTour = () => {
  const ctx = useContext(FormEditorTourContext);
  if (isNil(ctx)) {
    throw new Error("useFormEditorTour must be used within FormEditorTourProvider");
  }
  return ctx;
};
